import styled from '@eduzz/houston-styles';

const tagPrimaryColor = '#1D39C4';

export const TagContainer = styled.span`
  font-size: 0.75rem;
  color: ${tagPrimaryColor};
  border: 1px solid ${tagPrimaryColor};
  background-color: #d6e4ff;
  padding: 2px 8px;
  margin: 0 8px;
`;
